var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "outfit-card-background", class: _vm.containerClasses },
    [
      _c(
        "article",
        { staticClass: "outfit-card", class: _vm.cardClasses },
        _vm._l(_vm.getProductsOrderByPriority, function(product, index) {
          return _c(
            "div",
            {
              key: product.product_id,
              staticClass: "outfit-card-item",
              class: _vm.itemClasses[index],
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return function() {
                    return _vm.handleProductClk(product, _vm.outfit)
                  }.apply(null, arguments)
                }
              }
            },
            [
              _vm.swapProductClk !== undefined
                ? _c("swap-item-button", {
                    attrs: { classes: "icon", iconSize: "21px" },
                    on: {
                      click: function() {
                        return _vm.swapProductClk(product)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "outfit-card-item-image-container" }, [
                _c("img", {
                  ref: "image",
                  refInFor: true,
                  staticClass: "outfit-card-item-image",
                  attrs: {
                    src: product.product_image_url,
                    id: product.product_id
                  },
                  on: {
                    load: function($event) {
                      return _vm.loadImage(product.product_id)
                    }
                  }
                })
              ])
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("footer-buttons")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7029bca", { render: render, staticRenderFns: staticRenderFns })
  }
}